import { axiosClient } from "./axiosClient";
import BaseService from "./baseService";

export default class HttpService extends BaseService {
  http = axiosClient;
}
